"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _addDeviceEventObserverToSession = require("./addDeviceEventObserverToSession");
Object.keys(_addDeviceEventObserverToSession).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addDeviceEventObserverToSession[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _addDeviceEventObserverToSession[key];
    }
  });
});
var _audioVideo = require("./audioVideo");
Object.keys(_audioVideo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _audioVideo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _audioVideo[key];
    }
  });
});
var _contentShare = require("./contentShare");
Object.keys(_contentShare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _contentShare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contentShare[key];
    }
  });
});
var _deviceChange = require("./deviceChange");
Object.keys(_deviceChange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deviceChange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _deviceChange[key];
    }
  });
});
var _eventController = require("./eventController");
Object.keys(_eventController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _eventController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _eventController[key];
    }
  });
});
var _onPresenceChanged = require("./onPresenceChanged");
Object.keys(_onPresenceChanged).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _onPresenceChanged[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _onPresenceChanged[key];
    }
  });
});
var _subscribeToVolumeIndicator = require("./subscribeToVolumeIndicator");
Object.keys(_subscribeToVolumeIndicator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _subscribeToVolumeIndicator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _subscribeToVolumeIndicator[key];
    }
  });
});